import { useEffect } from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';
import { transformKeys } from '../services/transformers';

interface ContactCallObserverEvent {
  campaignContactId?: string | null;
}

interface UseContactCallRealtimeParams {
  contactId?: string;
  wsConnected: boolean;
  onCallChanged: () => void;
}

export function useContactCallRealtime({
  contactId,
  wsConnected,
  onCallChanged,
}: UseContactCallRealtimeParams) {
  const { subscribe } = useWebSocket();

  useEffect(() => {
    if (!contactId || !wsConnected) {
      return;
    }

    const subscription = subscribe(
      'call',
      { data: { contact_id: contactId } },
      (rawEvent: ContactCallObserverEvent, action: string) => {
        if (action !== 'create' && action !== 'update' && action !== 'delete') {
          return;
        }

        const event = transformKeys<ContactCallObserverEvent>(rawEvent);
        if (event.campaignContactId && event.campaignContactId !== contactId) {
          return;
        }

        onCallChanged();
      },
    );

    return () => {
      subscription?.unsubscribe?.();
    };
  }, [contactId, onCallChanged, subscribe, wsConnected]);
}

export default useContactCallRealtime;
